<template>
    <div class="container">
        <div class="visual">
            <img class="d-md-none" :src="mobileVisual" alt="">
            <img class="d-none d-md-block" :src="desktopVisual" alt="">
        </div>
        <div class="bloc-text bg-gray2">
            <div class="inside-bloc-text text-center p-2">
                <p v-if="text" class="h3 mb-0" v-html="text" />
                <h2 class="h3 mb-0">
                    <span v-html="subtitle" />
                    <span v-if="recoveryDeviceModel && recoveryAmountInCents > 0" class="text-primary">
                        {{ recoveryDeviceModel }}
                        <span v-if="!manualEstimation"> {{ '&nbsp;?' }}</span>
                    </span>
                </h2>
                <template v-if="advantages">
                    <p class="py-0 mb-0">
                        <strong class="icon-rewards me-1 font-size-34 text-primary" /><strong class="font-size-40" v-html="advantages" />
                    </p>
                    <p class="small mb-0 pt-0">
                        <small class="ps-3">{{ messages.recoveryText }}</small>
                        <small v-if="bonusAmountInCents > 0" class="ps-4">{{ messages.bonusText }}</small>
                    </p>
                </template>
                <div v-if="bonusRecoverySelectorLink && bonusRecoverySelectorLinkLabel" class="px-lg-4 px-xl-5">
                    <!--Cas où il faut afficher un lien vers le sélecteur de terminaux (bouton)-->
                    <ob1-boutons
                        class="mt-1"
                        :is-button="false"
                        :is-inverse="true"
                        :href="bonusRecoverySelectorLink"
                        :is-secondary="true"
                        target="_blank"
                        :label="bonusRecoverySelectorLinkLabel"
                        data-oevent-label="vers_selecteur_avec_filtre_bonus"
                        data-oevent-category="ajout_bonus_reprise"
                        data-oevent-action="decouvrir_notre_selection"
                    />
                    <div>
                        <!--L'accès au simulateur est alors fait via un lien-->
                        <ob1-liens
                            class="mt-1 d-inline"
                            is-button
                            :with-arrow="true"
                            :modal-id="recoveryModalId"
                            :text="messages.ctaLabel"
                            data-bs-toggle="modal"
                            :data-bs-target="'#' + simulatorModalId"
                            data-oevent-label="vers_simulateur"
                            data-oevent-category="Banniere_reprise_mobile"
                            data-oevent-action="j_accede_au_simulateur"
                        />
                    </div>
                </div>
                <template v-else>
                    <!--Cas où il n'y a pas de lien vers le sélecteur de terminaux.
                        L'accès au simulateur est alors fait via un bouton-->
                    <ob1-boutons
                        class="mt-1"
                        :is-secondary="true"
                        :is-inverse="true"
                        :label="messages.ctaLabel"
                        data-bs-toggle="modal"
                        :data-bs-target="'#' + simulatorModalId"
                        data-oevent-label="vers_simulateur"
                        data-oevent-category="Banniere_reprise_mobile"
                        data-oevent-action="j_accede_au_simulateur"
                    />
                    <div v-if="recoveryModalId" class="text-center">
                        <!--Lien vers la popin de reprise-->
                        <ob1-liens
                            class="mt-1 d-inline"
                            is-button
                            :with-arrow="true"
                            :modal-id="recoveryModalId"
                            data-bs-toggle="modal"
                            :text="messages.linkLabel"
                            data-oevent-label="vers_popin_reprise"
                            data-oevent-category="Banniere_reprise_mobile"
                            data-oevent-action="tout_savoir_sur_la_reprise"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "SoshMobileRecovery",
    props: {
        recoveryAmountInCents: {
            type: Number,
            default: null
        },
        recoveryDeviceModel: {
            type: String,
            default: null
        },
        manualEstimation: {
            type: Boolean,
            default: null
        },
        bonusAmountInCents: {
            type: Number,
            default: null
        },
        simulatorModalId: {
            type: String,
            required: true
        },
        recoveryModalId: {
            type: String,
            default: undefined
        },
        bonusRecoverySelectorLink: {
            type: String,
            default: null
        },
        bonusRecoverySelectorLinkLabel: {
            type: String,
            default: null
        },
        messages: {
            type: Object,
            required: true
        },
        desktopVisual: {
            type: String,
            required: true
        },
        mobileVisual: {
            type: String,
            required: true
        }
    },
    computed: {
        subtitle() {
            if (!this.recoveryDeviceModel) {
                return this.messages.prospectSubtitle;
            } else if (this.recoveryAmountInCents > 0) {
                if (this.manualEstimation === true) {
                    return this.messages.estimatedSubtitle;
                } else {
                    return this.messages.identifiedSubtitle;
                }
            } else {
                return this.messages.recyclingSubtitle;
            }
        },
        text() {
            if (!this.recoveryDeviceModel || (this.manualEstimation === true && this.recoveryAmountInCents > 0)) {
                return undefined;
            } else if (this.recoveryAmountInCents > 0) {
                return this.messages.identifiedText + " " + this.formatAmount(this.recoveryAmountInCents);
            } else {
                return this.recoveryDeviceModel;
            }
        },
        advantages() {
            if (this.manualEstimation === true && this.recoveryAmountInCents > 0) {
                let advantages = this.formatAmount(this.recoveryAmountInCents);
                if (this.bonusAmountInCents > 0) {
                    advantages += " + " + this.formatAmount(this.bonusAmountInCents);
                }
                return "<span class=\"text-primary\">" + advantages + "</span>";
            } else {
                return undefined;
            }
        }
    },
    methods: {
        formatAmount: function (amountInCents) {
            if (amountInCents) {
                return PriceFormatter.formatEurosWithSpace(amountInCents / 100, false).toString();
            } else {
                return null;
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 0;
}

.visual {
    width: 100%;
}

.visual img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.bloc-text {
    width: 90%;
    margin-top: -3.5rem;
    z-index: 1;
}

@media (min-width: #{map-get($grid-breakpoints, md)}) {
    .container {
        display: block;
        height: px-to-rem(300);
        overflow: hidden;
    }

    .visual {
        height: 100%;
    }

    .bloc-text {
        position: absolute;
        top: 50%;
        left: 50%;
        width: min(90%, 60rem);
        margin-top: 0;
        transform: translate(-50%, -50%);
    }

    .bloc-text.bg-gray2 {
        background-color: transparent !important;
    }

    .inside-bloc-text {
        width: 100%;
        background: transparent;
    }
}

</style>
